<template>
  <div class="modal" @mousedown.stop="closeModal">
    <div class="modal__box">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    closeModal(event) {
      if (!event.target.closest(".modal__box")) {
        this.$emit("close");
      }
    },
  },
};
</script>
<style scoped>
.modal {
  z-index: 9999999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.64);
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
}

.modal__box {
  position: absolute;
  box-sizing: border-box;
  background-color: var(--white);
  bottom: 0;
  box-shadow: 0px 8px 16px -4px rgba(63, 83, 107, 0.08);
}

.modal__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-weight: 500;
  color: var(--gray-700);
}

.modal__header img {
  cursor: pointer;
}

.modal__close {
  display: flex;
  align-items: flex-end;
}

@media all and (min-width: 1024px) {
  .modal__box {
    width: 880px;
    height: 90%;
    padding: 40px 40px 40px 40px;
    border-radius: 56px 56px 0px 0px;
  }

  .modal__header {
    font-size: 24px;
    line-height: 32px;
  }

  .modal__header img {
    width: 32px;
    height: 32px;
  }
}

@media all and (max-width: 1023px) {
  .modal__box {
    width: 100%;
    height: 90%;
    padding: 20px 20px 20px 20px;
    border-radius: 24px 24px 0px 0px;
  }
  .modal__header {
    margin-bottom: 32px;
    font-size: 20px;
    line-height: 28px;
  }

  .modal__header img {
    width: 24px;
    height: 24px;
  }
}
</style>
